import { render, staticRenderFns } from "./news.vue?vue&type=template&id=73532db0&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=73532db0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseOrnamentBg: require('/opt/airport.kg/src/components/base/ornament-bg.vue').default,NewsList: require('/opt/airport.kg/src/components/news/list.vue').default,RzContainer: require('/opt/airport.kg/node_modules/razlet-ui/src/components/container/index.vue').default})
